import React from 'react'

import { TopFilters as TopFiltersWrapper } from '@app/components'
import { LntSelect } from '@app/components/base'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { CONTRACTORS_KEY, LOCATION_KEY } from '@app/constants/queryKeys'

import { getStores } from '@app/api/routes/locationStores'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getSalesOrganization } from '@app/api/routes/locationSalesOrganization'
import { getContractors } from '@app/api/routes/contractors'

import { useFiltersSearch } from '@app/hooks'
import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { commonSelectProps } from './configs'

import type { MonitoringTabTopFiltersProps } from './types'

export const TopFilters: React.FC<MonitoringTabTopFiltersProps> = ({ onSearch, initialFilters }) => {
  const { filters, canResetFilters, handleClearFilters, handleSearch, handleSelectFilterChange } = useFiltersSearch({
    initialFilters,
    onSearch
  })

  return (
    <TopFiltersWrapper
      canReset={ canResetFilters }
      onClear={ handleClearFilters }
      onSearch={ handleSearch }
    >
      <LntSelect
        { ...commonSelectProps }
        value={ filters.storeIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.storeIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.storesFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationStoresItems],
          queryFn: getStores,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.clusterIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.clusterIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClustersItems],
          queryFn: getClusters,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.salesOrganizationIds ?? [] }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.salesOrganizationIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.salesOrganizationFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationSalesOrganizationsItems],
          queryFn: getSalesOrganization,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.contractorIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.contractorIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.contractorsFilter }
        querySelect={ {
          queryKey: [CONTRACTORS_KEY.contractorsItems],
          queryFn: getContractors,
          select: getFilterFromEntities
        } }
      />
    </TopFiltersWrapper>
  )
}
